class ShipsOnSync extends HTMLElement {
  connectedCallback() {
    this.sync();
  }
 
  sync() {
    const rows = document.querySelectorAll('[data-key][data-line-fresh-ships-on]');
 
    rows.forEach((row) => {
      const freshValue = row.getAttribute('data-line-fresh-ships-on');
      if (!freshValue) return; // preorder items don't carry this property
 
      const propertiesRaw = row.getAttribute('data-line-properties');
      let properties;
      try {
        properties = JSON.parse(propertiesRaw);
      } catch (e) {
        return;
      }
 
      // Shopify serializes item.properties as [] (an array) when a line
      // has no custom properties at all, instead of {} (an object).
      // Normalize it so we always send a proper object to the Cart API.
      if (Array.isArray(properties)) {
        properties = {};
      }
 
      const currentValue = properties['Ships on'];
      if (currentValue === freshValue) return; // already correct
 
      properties['Ships on'] = freshValue;
 
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: row.getAttribute('data-key'),
          quantity: parseInt(row.getAttribute('data-line-quantity'), 10),
          properties: properties,
        }),
      }).catch((err) => {
        console.error('Failed to refresh Ships on property:', err);
      });
    });
  }
}
 
if (!customElements.get('ships-on-sync')) {
  customElements.define('ships-on-sync', ShipsOnSync);
}